/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

import { Component } from '@angular/core';

import type { LocationBrief } from '@recruitee/locations-types';
import { TruncateComponent } from '@recruitee/user-interface';

@Component({
  imports: [TruncateComponent],
  selector: 'rt-location-address-cell',
  template: `
    @for (location of locations; track trackById($index, location)) {
      <rt-truncate>
        {{ location.fullAddress }}
      </rt-truncate>
    }
  `,
  styleUrls: ['./location-address-cell.component.less'],
  host: {
    '[class]': '"location-address-container"',
  },
  inputs: LocationAddressCellComponent.NgInputs,
})
export class LocationAddressCellComponent {
  public static NgInputs = ['locations' as const];

  public locations: LocationBrief[];

  public trackById = (index: number, item: LocationBrief) => item.id;
}
